import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT


//获取列表数据
export const list = (params) => {
  return axios.post(root+'/pay/paydetail2/list', qs.stringify(params))
}

export const listCategory = () => {
  return axios.post(root+'/pay/paydetail2/listCategory', null)
}


export const detail = (params) => {
  return axios.post(root+'/pay/paydetail2/detail', qs.stringify(params))
}

//删除行
export const save = (params) => {
  return axios.post(root+'/pay/paydetail2/save',  qs.stringify(params))
}

//获取某一行的明细数据
export const update = (params) => {
  return axios.get(root+'/pay/paydetail2/update',  {params:params})
}


export const remove=(params)=>{
  return axios.post(root+'/pay/paydetail2/remove', qs.stringify(params))
}

/////////////////////////////////////////////////下面是 报销流程的/////////////////////////////////////////////////////////////

//根据uguid，和分类编码 获取未提交的费用明细，不分页
export const getUnSubmitPayDetailList=(params)=>{
  return axios.post(root + '/pay/paydetail/getUnSubmitPayDetailList', qs.stringify(params))
};
//根据payguid 获取未提交的费用明细，不分页
export const getPayDetailByPayGuid=(params)=>{
  return axios.post(root + '/pay/paydetail/getPayDetailByPayGuid', qs.stringify(params))
};


export const getListData = (params) => {
  return axios.post(root + '/pay/paydetail/list', qs.stringify(params))
}

// 按月分组统计
export const getFeeMoneyByMonth = (params) => {
  return axios.post(root + '/pay/paydetail/getFeeMoneyByMonth', qs.stringify(params))
}

//删除行
export const deleteFeeDetail = (params) => {
  return axios.post(root + '/pay/paydetail/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/pay/paydetail/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params, flag) => {

  if (!flag) {//修改
    return axios.post(root + '/pay/paydetail/update', qs.stringify(params))
  } else {
    return axios.post(root + '/pay/paydetail/save', qs.stringify(params))
  }
}

//更新发票抵扣状态
export const updatehasdikou = (params,) => {

  return axios.post(root + '/pay/paydetail/updatehasdikou', qs.stringify(params))

}

export const fentanDetail= (params,) => {
  return axios.post(root + '/pay/payfentandetail/listbyfentanguid', qs.stringify(params))
}

export const savefentanData= (params,) => {
  return axios.post(root + '/pay/payfentandetail/savefentanData', qs.stringify(params))
}








// WEBPACK FOOTER //
// ./src/api/pay/paydetail.js